import { render } from "./ApprovedRequest.vue?vue&type=template&id=de501050"
import script from "./ApprovedRequest.vue?vue&type=script&lang=js"
export * from "./ApprovedRequest.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__